import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

type DateInput = string | number | Date;

type UseTimeAgoOptions = {
  format?: string;
};

const useTimeAgo = (date?: DateInput, options?: UseTimeAgoOptions): string => {
  const { format = 'mm:ss' } = options || {};

  const getTimeElapsed = () => {
    const diff = dayjs().diff(dayjs(date), 'second');
    const formatted = dayjs.duration(diff, 'seconds').format(format);
    return formatted;
  };

  const [timeAgo, setTimeAgo] = useState<string>(getTimeElapsed);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo(getTimeElapsed());
    }, 1000);

    return () => clearInterval(interval);
  }, [date, format]);

  return timeAgo;
};

export default useTimeAgo;
